




































import _ from 'lodash'
import { Mixins, Component, Prop, Emit } from 'vue-property-decorator'
import TcwFormItemCommon from '@/components/common/form/mixins/TcwFormItemCommon'
import TcwFormItem from '@/components/common/form/TcwFormItem.vue'
import { DEFAULT_UPLOAD_FILE_MAX_SIZE } from '@/tcw/constant/TcwConstant'
import { ElUploadInternalFileDetail, FileListItem } from 'element-ui/types/upload'

export type FileUploadErrorType = 'UPLOAD_SIZE_OVER'

@Component({
  components: { TcwFormItem }
})
export default class TcwFormItemFileUpload extends Mixins(TcwFormItemCommon) {
  @Prop({ default: () => [] })
  private fileList!: FileListItem[]
  @Prop({ default: DEFAULT_UPLOAD_FILE_MAX_SIZE })
  private maxSize!: number
  @Prop({ type: Boolean, default: false })
  private multiple!: boolean
  @Prop({ type: Boolean, default: false })
  private allowClipboard!: boolean
  @Prop({ type: Boolean, default: false })
  private showFileList!: boolean
  @Prop({ type: Boolean, default: false })
  private onlyImage!: boolean
  @Prop({ type: Boolean, default: false })
  private allowDrag!: boolean
  @Prop({ default: 'el-icon-upload' })
  private iconClass!: string
  @Prop({ default: 'Drop file here or <em>click to upload</em>' })
  private uploadAreaText!: string
  @Prop({ default: '' })
  private uploadAreaTooltip!: string
  @Prop({ type: Boolean, default: false })
  private undeliteable!: boolean

  private get dragable(): boolean {
    if (this.allowDrag === false) {
      return false
    }

    return this.$mq !== 'sp'
  }

  @Emit()
  private input(_value: Blob[]): void {
    //
  }

  @Emit()
  private uploadError(_value: FileUploadErrorType): void {
    //
  }

  @Emit()
  private handleFileAdd(_file: Blob): void {
    //
  }

  @Emit()
  private handleRemoveFile(_file: Blob): void {
    //
  }

  @Emit()
  private pasteFile(_blob: Blob): void {
    //
  }

  protected handleAdd(
    elFile: ElUploadInternalFileDetail,
    elFileList: ElUploadInternalFileDetail[]
  ): void {
    // 追加チェック
    const checkResult = this.checkFileAdd(elFile)
    if (checkResult) {
      this.handleFileAdd(elFile.raw)
      const fileList = elFileList.map(ef => ef.raw)
      this.input(fileList)
    } else {
      // 追加されたファイルを除去
      elFileList.splice(elFileList.length - 1, 1)
      const fileList = elFileList.map(ef => ef.raw)
      this.input(fileList)

      // エラーハンドリング
      this.uploadError('UPLOAD_SIZE_OVER')
    }
  }
  /**
   * ファイル除去イベント
   */
  protected handleRemove(file: File, fileList: File[]): void {
    this.handleRemoveFile(file)
    this.input(fileList)
  }
  /**
   * ファイル追加時のチェック処理
   * @param file ファイル
   * @returns チェックOK： true
   */
  protected checkFileAdd(file: ElUploadInternalFileDetail): boolean {
    //
    // ファイルサイズチェック
    return file.size ? file.size <= this.maxSize : false
  }

  // TODO クリップボードから貼り付け処理を実装
  // private async pasteImageFromClipboard() {
  //   const items = await navigator.clipboard.read()
  //   for(let item of items) {
  //     if(this.hasImage(item)) {
  //       // const blob = await item.getType('image')
  //       // const file = new File([blob], '')
  //       // const file = await this.getFile(item)
  //       const file = await this.getImage(item)
  //       this.pasteFile(file!)
  //       // if (this.checkFileAdd(file)) {
  //       //   const copyFileList = _.cloneDeep(this.value)
  //       //   copyFileList.push(file)
  //       //   this.input(copyFileList)
  //       // }
  //     } else {
  //       this.$tcw.message({
  //         type: 'warning',
  //         message: 'クリップボードにイメージがありません'
  //       })
  //     }
  //   }
  // }

  // private hasImage(item: ClipboardItem): boolean {
  //   return item.types.some(t => {
  //     return t.indexOf('image') != -1
  //   })
  // }

  // private getImage(item: ClipboardItem) {
  //   const type = item.types.find(t => {
  //     return t.indexOf('image') != -1
  //   })

  //   if (type) {
  //     return item.getType(type)
  //   } else {
  //     return null
  //   }
  // }

  // private async getFile(item: ClipboardItem): Promise<Blob> {
  //   console.log('getFile start')
  //   const blob = await item.getType('image/png')
  //   console.log('const blob = await item.getType(\'image\')')
  //   // const file = new File([blob], '')
  //   // console.log('const file = new File([blob], \'\')')
  //   return new File([blob], 'pastetest.png')
  // }
}
